import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  SimpleGrid,
  Spacer,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { ChevronRightIcon } from "@chakra-ui/icons";

import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";
import { useNavigate, useParams } from "react-router-dom";
import { UserAuth } from "../auth/AuthContext";
import { db } from "../firebase-config";
import AddEditMotorista from "./AddEditMotorista";
import ConfirmDialog from "./ConfirmDialog";
import EditCar from "./EditCar";
import MotoristaInfo from "./MotoristaInfo";
import TableGeral from "./TableGeral";

const CarroInfo = () => {
  const navigate = useNavigate();
  const [motoristas, SetMotoristas] = useState([]);
  const { carroId, filialId } = useParams();
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [eventos, setEventos] = useState([]);
  const { user } = UserAuth();

  useEffect(() => {
    carroId, filialId;
  }, [carroId, filialId]);

  const ListEvents = doc(
    db,
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
    filialId,
    carroId,
    "Eventos",
    "docEventos"
  );

  const getEvents = async () => {
    const docSnap = await getDoc(ListEvents);

    if (docSnap.exists()) {
      // console.log("Document data:", docSnap.data());
      setEventos(docSnap.data());
    } else {
      // doc.data() will be undefined in this case
      // console.log("No such document!");
    }
  };

  const ListMotoristas = collection(
    db,
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
    filialId,
    carroId,
    "Motoristas"
  );

  const getMotoristas = async () => {
    const data = await getDocs(ListMotoristas);
    SetMotoristas(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setLoading(false);
  };

  const DeletCar = async () => {
    if (user.email === "israelvcb@hotmail.com") {
      await deleteDoc(
        doc(db, "/FILIAIS/91IYpjJbXYN99Asq2Enw/", filialId, carroId),
        navigate(`/filial/${filialId}`, { replace: true }),
        ToastCarDelete()
      );
    } else {
      console.log("Permissão negada");
      ToastCarDeleteError();
    }
  };

  const ToastCarDelete = () => {
    return toast({
      title: "Carro excluido com sucesso!",
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const ToastCarDeleteError = () => {
    return toast({
      title: "Você não tem permissão para exluir carros!",
      position: "bottom",
      status: "error",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  // SÓ PUXA O GETMOTORISTAS UMA VEZ QUANDO CLICAR NA TABS MOTORISTAS
  const [selectedTab, setSelectedTab] = useState(0);
  const [isTabMotoristaLoaded, setIsTabMotoristaLoaded] = useState(false);
  const [isTabEvents, setIsTabEvents] = useState(false);

  useEffect(() => {
    if (selectedTab === 2 && !isTabMotoristaLoaded) {
      setIsTabMotoristaLoaded(true);
      getMotoristas();
    }
    if (selectedTab === 0 && !isTabEvents) {
      setIsTabEvents(true);
      getEvents();
    }
  }, [selectedTab, isTabEvents]);

  return (
    <>
      <Flex
        minWidth="max-content"
        alignItems="center"
        gap="2"
        direction={["column", "row"]}
        align="center"
      >
        <Box mb={2}>
          <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => navigate(`/`)}>
                Filial
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => navigate(`/filial/${filialId}`)}>
                {filialId}
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink> {carroId}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Box>
        <Spacer />
        <Flex direction="row" align="center" align-items="center" mb={4}></Flex>
      </Flex>

      <Tabs
        isFitted
        isManual
        size="md"
        onChange={handleTabChange}
        boxShadow="lg"
        rounded="lg"
        isLazy
      >
        <TabList mb="1em">
          <Tab
            borderColor={"cyan.600"}
            borderLeftRadius={5}
            textColor={"gray.900"}
            bg="gray.400"
            _selected={{
              color: "white",
              bgGradient: "linear(to-r, blue.500, green.500)",
              fontWeight: "bold",
            }}
          >
            Eventos
          </Tab>
          <Tab
            borderColor={"cyan.600"}
            textColor={"gray.900"}
            bg="gray.400"
            _selected={{
              color: "white",
              bgGradient: "linear(to-r, blue.500, green.500)",
              fontWeight: "bold",
            }}
          >
            Editar
          </Tab>
          <Tab
            borderColor={"cyan.600"}
            textColor={"gray.900"}
            bg="gray.400"
            _selected={{
              color: "white",
              bgGradient: "linear(to-r, blue.500, green.500)",
              fontWeight: "bold",
            }}
          >
            Motoristas
          </Tab>
          {/* <Tab
            borderColor={"cyan.600"}
            borderRightRadius={5}
            textColor={"gray.900"}
            bg="gray.400"
            _selected={{
              color: "white",
              bgGradient: "linear(to-r, blue.500, green.500)",
              fontWeight: "bold",
            }}
          >
            tab
          </Tab> */}
        </TabList>

        <TabPanels>
          <TabPanel>
            {user.email === "israelvcb@hotmail.com" ? (
              <ConfirmDialog DeletCar={DeletCar} />
            ) : null}

            <TableGeral eventos={eventos} getEvents={getEvents} />
          </TabPanel>

          <TabPanel>
            <EditCar />
          </TabPanel>

          <TabPanel>
            <Flex justifyContent="flex-end">
              <AddEditMotorista
                getMotoristas={getMotoristas}
                loading={loading}
                setLoading={setLoading}
              />
            </Flex>
            {loading ? (
              <Flex justifyContent="center" mt="15%">
                <Spinner
                  thickness="8px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="blue.500"
                  width={100}
                  height={100}
                />
              </Flex>
            ) : motoristas.length === 0 ? (
              <Flex justifyContent="center">
                NÃO EXISTEM MOTORISTAS CADASTRADOS
              </Flex>
            ) : (
              <SimpleGrid
                spacing={5}
                templateColumns="repeat(auto-fill, minmax(300px, 1fr))"
              >
                {motoristas.map((motoristas) => (
                  <MotoristaInfo
                    key={motoristas.id}
                    motoristas={motoristas}
                    getMotoristas={getMotoristas}
                    loading={loading}
                    setLoading={setLoading}
                  />
                ))}
              </SimpleGrid>
            )}
          </TabPanel>

          {/* <TabPanel>
            <TabelarEx />
          </TabPanel> */}
        </TabPanels>
      </Tabs>
    </>
  );
};

export default CarroInfo;
